<template>
  <div class="kortex-ocr-config">
    <b-form-group
      :label="$t('kortex.sourceType')"
      label-for="kortex-source-type"
    >
      <b-form-select
        id="kortex-source-type"
        v-model="localData.source_type"
        :options="sourceTypeOptions"
        @change="onSourceTypeChange"
      ></b-form-select>
    </b-form-group>

    <template v-if="localData.source_type === 'base64'">
      <b-form-group
        :label="$t('kortex.fileData')"
        label-for="kortex-file-data"
      >
        <b-form-textarea
          id="kortex-file-data"
          v-model="localData.file_data"
          :placeholder="$t('kortex.fileDataPlaceholder')"
          rows="3"
          @input="emitUpdate"
        ></b-form-textarea>
        <small class="text-muted">{{ $t('kortex.fileDataHint') }}</small>
      </b-form-group>
    </template>

    <template v-if="localData.source_type === 'dms'">
      <b-form-group
        :label="$t('kortex.dmsKey')"
        label-for="kortex-dms-key"
      >
        <b-form-input
          id="kortex-dms-key"
          v-model="localData.dms_key"
          :placeholder="$t('kortex.dmsKeyPlaceholder')"
          @input="emitUpdate"
        ></b-form-input>
        <small class="text-muted">{{ $t('kortex.dmsKeyHint') }}</small>
      </b-form-group>
    </template>
  </div>
</template>

<script>
export default {
  name: 'OCRNodeConfig',
  props: {
    value: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      localData: {
        source_type: 'base64',
        file_data: '',
        dms_key: ''
      }
    }
  },
  computed: {
    sourceTypeOptions: function () {
      return [
        { value: 'base64', text: this.$t('kortex.sourceTypeBase64') },
        { value: 'dms', text: this.$t('kortex.sourceTypeDms') }
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal) {
        if (!newVal) return
        if (newVal.source_type !== undefined && newVal.source_type !== this.localData.source_type) {
          this.localData.source_type = newVal.source_type
        }
        if (newVal.file_data !== undefined && newVal.file_data !== this.localData.file_data) {
          this.localData.file_data = newVal.file_data
        }
        if (newVal.dms_key !== undefined && newVal.dms_key !== this.localData.dms_key) {
          this.localData.dms_key = newVal.dms_key
        }
      }
    }
  },
  mounted: function () {
    if (this.value) {
      if (this.value.source_type !== undefined) this.localData.source_type = this.value.source_type
      if (this.value.file_data !== undefined) this.localData.file_data = this.value.file_data
      if (this.value.dms_key !== undefined) this.localData.dms_key = this.value.dms_key
    }
  },
  methods: {
    onSourceTypeChange: function () {
      // Clear the other field when switching source type
      if (this.localData.source_type === 'base64') {
        this.localData.dms_key = ''
      } else {
        this.localData.file_data = ''
      }
      this.emitUpdate()
    },
    emitUpdate: function () {
      this.$emit('input', Object.assign({}, this.localData))
    }
  }
}
</script>

<style scoped>
.kortex-ocr-config {
  padding: 4px 0;
}
</style>
